import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useAuth } from "../../context/AuthContext";
import { Box } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import Modal from "../../components/Modal/Modal";

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [modalData, setModalData] = useState({
		isVisible: false,
		message: "",
		type: "",
	});
	const { login: authLogin } = useAuth();
	const navigate = useNavigate();

	const handleLogin = async (event) => {
		event.preventDefault();

		const loginData = {
			username: username,
			password: password,
		};

		try {
			const response = await fetch(
				`${API_URL}/accounts/api-token-auth/`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(loginData),
				}
			);
			if (response.ok) {
				const data = await response.json();
				authLogin(data);
				const isAdmin = data.is_admin;

				localStorage.setItem("show_modal", "true");
				isAdmin
					? navigate("/admin/dashboard")
					: navigate("/user/dashboard");
			} else {
				const errorData = await response.json();
				setModalData({
					isVisible: true,
					message: errorData.error,
					type: "error",
				});
			}
		} catch (error) {
			setModalData({
				isVisible: true,
				message: "مشکلی پیش آمده است. لطفا دوباره تلاش کنید",
				type: "error",
			});
		}
	};

	const handleKeycloakLogin = () => {
		const returnPath = window.location.pathname;
		localStorage.setItem("returnPath", returnPath);

		window.location.href = "https://sso.kntu.ac.ir/realms/kntu/protocol/openid-connect/auth?client_id=cv.kntu.ac.ir&response_type=code&redirect_uri=https://cv.kntu.ac.ir/callback&scope=openid";
	};

	return (
		<div className="container without-navbar">
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					px: 2,
					width: "400px",
					margin: "50px 0",
				}}
			>
				<img src="/kntu.ico" alt="khajeh-logo" className="login-logo" />
				<h1 className="login-title">ورود به سیستم</h1>
				<form
					className="login-form"
					onSubmit={handleLogin}
					method="post"
				>
					<div className="login-form-group">
						<label htmlFor="username" className="username-label">
							نام کاربری
						</label>
						<div className="username-wrapper">
							<input
								className="username-input"
								type="text"
								id="username"
								name="username"
								tabIndex="1"
								value={username}
								onChange={(event) =>
									setUsername(event.target.value)
								}
								required
							/>
							<button type="button" className="username-icon">
								<PersonIcon fontSize="large" />
							</button>
						</div>
					</div>
					<div className="form-group">
						<label htmlFor="password" className="password-label">
							رمز عبور
						</label>
						<div className="password-wrapper">
							<input
								className="password-input"
								type={showPassword ? "text" : "password"}
								id="password"
								name="password"
								tabIndex="2"
								value={password}
								onChange={(event) =>
									setPassword(event.target.value)
								}
								required
							/>
							<button
								type="button"
								className="toggle-password"
								onClick={() => setShowPassword(!showPassword)}
							>
								{showPassword ? (
									<Visibility fontSize="large" />
								) : (
									<VisibilityOff fontSize="large" />
								)}
							</button>
						</div>
					</div>
					<button
						className="login-button medium-text"
						type="submit"
						tabIndex="3"
					>
						ورود
					</button>
					<Box
						display="flex"
						justifyContent="center"
						alignItems="start"
						flexDirection="column"
						width="100%"
						marginTop="20px"
					>
						<a href="https://sso.kntu.ac.ir/realms/kntu/login-actions/reset-credentials" className="login-link">
							رمز عبور خود را فراموش کرده اید؟
						</a>
						<button
							className="login-link-btn regular-text"
							onClick={handleKeycloakLogin}							
						>
							ورود با حساب دانشگاهی
						</button>
					</Box>
				</form>
				<Modal
					message={modalData.message}
					type={modalData.type}
					isVisible={modalData.isVisible}
					onClose={() =>
						setModalData({ ...modalData, isVisible: false })
					}
				/>
			</Box>
		</div>
	);
};

export default Login;
